import React from 'react';
import { Pressable, ScrollView, StyleSheet, View } from 'react-native';
import { SubMenuItem } from '@/components/ui/therapist/CollapsibleSidebar/SubMenuItem';
import { useSidebarAnimation } from '@/components/ui/therapist/CollapsibleSidebar/SidebarAnimationContext';
import { SubMenuItem as SubMenuItemInterface } from '@/components/ui/therapist/CollapsibleSidebar';

import { styles } from './styles';

export const SubMenu = ({
  subMenu,
  setExpandedSubMenu,
}: {
  subMenu: SubMenuItemInterface[] | null;
  setExpandedSubMenu: (submenu: SubMenuItemInterface[] | null) => void;
}) => {
  const { sidebarWidthValue } = useSidebarAnimation();

  if (!subMenu) {
    return null;
  }

  return (
    <View style={styles.subMenuOverlay} pointerEvents="box-none">
      <Pressable
        style={StyleSheet.absoluteFill}
        onPress={() => setExpandedSubMenu(null)}
      />
      <View style={[styles.subMenuWrapper, { left: sidebarWidthValue }]}>
        <ScrollView>
          {subMenu.map((subItem, idx) => (
            <SubMenuItem
              key={idx}
              setExpandedSubMenu={setExpandedSubMenu}
              subItem={subItem}
            />
          ))}
        </ScrollView>
      </View>
    </View>
  );
};
